<template>
    <label class="mb-2 small" :for="label">{{ label }}</label>
    <Multiselect
        v-bind="$attrs"
        :value="modelValue" 
        :options="options" 
        :searchable="searchable" 
        :close-on-select="close_on_select" 
        :show-labels="show_labels" 
        :placeholder="label"
        :track-by="track_by"
        @change="$emit('update:modelValue', $event.target.value), validate($event.target.value)"
        class="form-control"
    />
    <span v-if="validationState.error" class="text-danger small">{{ validationState.message }}</span>
</template>
<script>
    import validator from '@/config/validator'
    import Multiselect from 'vue-multiselect'
    import { reactive } from 'vue'

    export default {
        name:'BaseSelect1',
        components: {
            Multiselect
        },
        props: {
            label: {
                type: String,
                default:null
            },
            modelValue: {
                type: [String,Number,Object,Array,Boolean],
                default: null
            },
            name: {
                type: String,
            },
            rules: {
                type: String,
                default: null
            },


            options: {
                type: Array,
                default:[]
            },
            searchable: {
                type:Boolean,
                default:true
            },
            close_on_select: {
                type:Boolean,
                default:false
            },
            show_labels: {
                type:Boolean,
                default:false
            },
            track_by: {
                type:String,
                default:'id'
            }

        },

        setup: async (props, { emit }) => {

            const validationState = reactive({
                error: false,
                field: null,
                message: null,
            })

            const setState = function(data=false){
                validationState.error = data.val || false
                validationState.message = data.message || null
                validationState.field = data.name || null
            }

            const validate = async function(value) {
                if(!props.rules) return emit('valSuccess', { error:false, field: props.name });
                try{
                    let result = await validator.validateForm(props.name, props.rules, value)
                    if(!result.success){
                        setState({val:true, message: result?.message, name: result?.field_name})
                        emit('valError', { error: true, field: result?.field_name })
                        return
                    }
                    setState()
                    emit('valSuccess', {error: false, field: result?.field_name })
                    return
                }
                catch(err){
                    console.log(err)
                } 
                return
            }

            return {
                validate,
                validationState
            }
        },

        
    }
</script>